import { render, staticRenderFns } from "./NovoSubMenu.vue?vue&type=template&id=cbac3ecc"
import script from "./NovoSubMenu.vue?vue&type=script&lang=js"
export * from "./NovoSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports